"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@material-ui/core");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var icons_1 = require("../../../styles/config/icons");
var objectUtilities_1 = require("../../../util/objectUtilities");
var Icon_style_1 = __importDefault(require("./Icon.style"));
/**
 * Icon atom
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/atoms-icons-icon--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/atoms/Icon Source}
 */
exports.Icon = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, color = _a.color, fill = _a.fill, hoverVariant = _a.hoverVariant, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, iconPath = _a.iconPath, transition = _a.transition, _b = _a.size, size = _b === void 0 ? icons_1.defaultIconSize : _b, rest = __rest(_a, ["className", "color", "fill", "hoverVariant", "onClick", "onMouseDown", "onMouseEnter", "onMouseLeave", "iconPath", "transition", "size"]);
    var classes = (0, Icon_style_1.default)();
    function getHoverClass() {
        switch (hoverVariant) {
            case 'default':
                return classes.hoverDefault;
            case 'error':
                return classes.hoverError;
            case 'primaryDark':
                return classes.hoverPrimaryDark;
            case 'errorDark':
                return classes.hoverErrorDark;
            case 'opacity':
                return classes.hoverOpacity;
            case undefined:
                return undefined;
            default:
                return (0, objectUtilities_1.exhaustivenessCheck)(hoverVariant);
        }
    }
    var styleOverride = {
        transition: transition,
        width: typeof size === 'number' ? size : size.width,
        height: typeof size === 'number' ? size : size.height,
    };
    return ((0, jsx_runtime_1.jsxs)(core_1.SvgIcon, __assign({ role: onClick ? 'button' : 'img', viewBox: iconPath.viewBox, ref: ref, style: styleOverride, className: (0, classnames_1.default)(className, classes.root), onClick: onClick, onMouseDown: onMouseDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }, rest, { "aria-hidden": false }, { children: [fill && (0, jsx_runtime_1.jsx)("path", { d: fill.path, fill: fill.color || color, fillRule: iconPath.fillRule }), (0, jsx_runtime_1.jsx)("path", { d: iconPath.path, fill: color, fillRule: iconPath.fillRule, transform: iconPath.transform, className: getHoverClass() }), iconPath.secondPath && (0, jsx_runtime_1.jsx)("path", { d: iconPath.secondPath, fill: color })] })));
});
